import e from"styled-components";const i=e.div`
	padding: ${({isSingleColumn:e})=>e?"24px":"16px"};
	border-radius: ${({borderRadius:e})=>`${e}px`};
	display: flex;
	flex-direction: ${({isSingleColumn:e})=>e?"row":"column"};
	justify-content: ${({isSingleColumn:e})=>e?"normal":"space-between"};
	align-items: ${({isSingleColumn:e})=>e?"center":"normal"};
	gap: 40px;
	height: 100%;
	box-sizing: border-box;
	box-shadow: 0px 0.628px 3.138px 0px rgba(63, 65, 66, 0.2);
	background-color: ${({backgroundColor:e})=>e};
	color: ${({textColor:e})=>e};
`,o=e.div`
	display: flex;
	flex-direction: column;
	gap: 8px;
	order: ${({isSingleColumn:e})=>e?1:0};
	flex: 1;
`,n=e.h1`
	all: unset;
	color: inherit;
	font-size: 22px;
	font-weight: 600;
	line-height: 24px;
	min-height: 24px;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,l=e.div`
	min-height: 33px;
`,t=e.p`
	all: unset;
	color: inherit;
	font-size: 14px;
	line-height: 20px;
	white-space: pre-wrap;
	flex: 1;
	opacity: 0.8;
	cursor: ${({isEditable:e=!1})=>e?"text":"default"};
`,r=e.div`
	color: inherit;
	font-size: ${({isSingleColumn:e})=>e?"120px":"40px"};
	font-style: normal;
	font-weight: 600;
	line-height: 100%;
`;export{i as CardContainer,o as CardContentContainer,n as CardHeading,t as CardParagraph,l as CardParagraphContainer,r as CardStep};
